/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react"

import { useLayerPopupContext } from "@shared/contexts"

function PartnerInfo() {
  const { close } = useLayerPopupContext()

  return (
    <article
      className="popup"
      style={{ width: "430px", margin: "-145px 0 0 -215px" }}
    >
      <div className="titB">
        <h1>파트너 소개</h1>
        <a
          href="#!"
          title="닫기"
          onClick={(e) => {
            e.preventDefault()
            close()
          }}
        >
          닫기
        </a>
      </div>
      <div className="iframeB" style={{ backgroundColor: "#1d222b" }}>
        <iframe
          src="http://www.wownet.co.kr/"
          style={{ width: "100%", height: "250px" }}
        ></iframe>
      </div>
    </article>
  )
}

export default PartnerInfo
